import { IMAGE_SRC_TYPES } from "@/config/image";

const imagesMicroserviceSizes = {
  'xs': '?size=xs',
  'sm': '?size=sm',
  'md': '?size=md',
  'lg': '?size=lg',
  'xl': '?size=xl'
};

export default {
  [IMAGE_SRC_TYPES.IMAGE]: {
    'xs': '&size=xs',
    'sm': '&size=sm',
    'md': '&size=md',
    'lg': '&size=lg',
    'xl': '&size=xl'
  },
  [IMAGE_SRC_TYPES.DROPBOX]: imagesMicroserviceSizes,
  [IMAGE_SRC_TYPES.UPLOAD]: imagesMicroserviceSizes,
  [IMAGE_SRC_TYPES.YOUTUBE]: {
    'xs': '/mqdefault.jpg',
    'sm': '/mqdefault.jpg',
    'md': '/hqdefault.jpg',
    'lg': '/sddefault.jpg',
    'xl': '/maxresdefault.jpg'
  }
}
